import React from 'react'
import PropTypes from 'prop-types'
import { Popup } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import propTypeDeprecated from '../../../utils/propTypeDeprecated'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const SMALL_WIDTH_THAT_NEEDS_FUDGING = 32
const NUDGE_AMOUNT = 11

const PopupTooltip = ({
  offset,
  horizontalOffset,
  verticalOffset,
  position = 'top center',
  hoverable = true,
  flowing = false,
  popperModifiers = [],
  ...remainingProps
}) => {
  let newOffset = offset
  if (newOffset === undefined) {
    if (horizontalOffset !== undefined) {
      newOffset = horizontalOffset
    } else if (verticalOffset !== undefined) {
      newOffset = verticalOffset
    }
  }

  return (
    <Popup
      className={cx('container')}
      offset={[newOffset, 0] || [0, 0]} // note: latest version of semantic-ui-react expects a tuple. see docs.
      position={position}
      hoverable={hoverable}
      flowing={flowing}
      // this modifier is used to nudge the tooltip to the left or right if the reference element is too small
      popperModifiers={[
        {
          name: 'offset',
          options: {
            offset: ({ placement, reference, popper }) => {
              if (reference.width <= SMALL_WIDTH_THAT_NEEDS_FUDGING) {
                if (placement.includes('end')) {
                  return [NUDGE_AMOUNT, 0]
                } else if (placement.includes('start')) {
                  return [0 - NUDGE_AMOUNT, 0]
                }
              }
              return []
            },
          },
        },
        ...popperModifiers,
      ]}
      {...remainingProps}
    />
  )
}

PopupTooltip.propTypes = {
  className: PropTypes.any,
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  horizontalOffset: propTypeDeprecated('horizontalOffset', 'offset'),
  verticalOffset: propTypeDeprecated('verticalOffset', 'offset'),
  position: PropTypes.string,
  hoverable: PropTypes.bool,
  flowing: PropTypes.bool,
  popperModifiers: PropTypes.array,
}

export default PopupTooltip
